import { ForwardedRef, forwardRef, SelectHTMLAttributes } from 'react'

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  variant?: 'primary' | 'secondary' | 'danger'
  placeholder?: string
  helperText?: string
  options: string[]
}

export const Select = forwardRef(
  (
    {
      variant = 'primary',
      className,
      helperText,
      placeholder,
      options,
      ...rest
    }: SelectProps,
    ref: ForwardedRef<HTMLSelectElement>,
  ) => {
    const variantClasses = {
      primary: 'shadow-md w-full order-blue-500 focus:border-blue-600',
      secondary: 'border-gray-300 focus:border-gray-400',
      danger:
        'shadow-md bg-red-50 border border-red-500 text-red-900 ' +
        'placeholder-red-700 text-sm rounded-lg focus:ring-red-500 ' +
        'focus:border-red-500 block w-full p-2.5',
    }

    return (
      <div className="relative">
        <select
          ref={ref}
          className={`rounded-md border px-4 py-2 placeholder-black 
          focus:outline-none focus:ring-2 focus:ring-${variant}-500 ${variantClasses[variant]} ${className}`}
          {...rest}
        >
          {placeholder && <option value="">{placeholder}</option>}
          {options.map((option, index) => (
            <option key={index} value={option}>
              {option}
            </option>
          ))}
        </select>
        <p className="mt-2 text-sm text-red-600">{helperText}</p>
      </div>
    )
  },
)
